import { faClockRotateLeft, faThumbTack } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import { useAuth } from "../../../../firebase/AuthProvider";

const TaskCreationSelector: React.FC = () => {
  const { currentRoles } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedTab, setSelectedTab] = useState("interimtask_tab");

  useEffect(() => {
    // Sync state with current route on mount or when path changes
    // if (location.pathname.includes("interim")) {
    //   setSelectedTab("interimtask_tab");
    // } else {
    //   setSelectedTab("recurringtask_tab");
    // }
    if (location.pathname.includes("interim")) {
      setSelectedTab("interimtask_tab");
    } else {
      setSelectedTab("interimtask_tab"); // always use interim now
    }
  }, [location.pathname]);

  // const handleTabSelect = (key: string | null) => {
  //   if (!key) return;
  //   setSelectedTab(key);

  //   if (key === "recurringtask_tab") {
  //     navigate("/addtask/new/recurring");
  //   } else if (key === "interimtask_tab") {
  //     navigate("/addtask/new/interim");
  //   }
  // };


  const handleTabSelect = (key: string | null) => {
  if (!key) return;
  setSelectedTab(key);

  if (key === "interimtask_tab") {
    navigate("/addtask/new/interim");
  }
};


  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-xl-9 mx-auto">
          <div className="common_card">
            {/* <div className="top mby_16">
                  <div className="top_bar_tittle">
                      <h2>Select the type of task to create!</h2>
                  </div>
              </div> */}
            <Tab.Container activeKey={selectedTab} onSelect={handleTabSelect}>

              {currentRoles?.some((role) => {
                return (role.name.toUpperCase() === "PROGRAM MANAGER"
                  || (role.name.toUpperCase() === "OWNER"))
              }) &&
                <Nav variant="pills" className="common_tab mby_24">
                  <Nav.Item>
                    <Nav.Link eventKey="interimtask_tab">
                      <FontAwesomeIcon icon={faThumbTack} className="me-2" />
                      Interim Task
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="recurringtask_tab">
                      <FontAwesomeIcon icon={faClockRotateLeft} className="me-2" />
                      Recurring Task
                    </Nav.Link>
                  </Nav.Item> */}
                </Nav>
              }
              <Tab.Content>
                <Outlet />
              </Tab.Content>
            </Tab.Container>

          </div>
        </div>
      </div>
      {/* <div className="">
        {paramValue === "true" && <div className="mt-5"><Banner dismissBanner={dismissBanner} status="success" message={""} /></div>}
        <h2 className="title important mt-10">
          Select the type of task to create!
        </h2>
        <div className="flex gap-5 text-text dark:text-text-dark justify-center flex-wrap">
          <div
            className="cursor-pointer bg-card dark:bg-card-dark p-10 w-96 my-5 rounded-lg shadow-xl hover:shadow-sm hover:bg-text-dark hover:dark:bg-text hover:text-primary"
            onClick={() => navigate("/addtask/new/recurring")}
          >
            <div className="text-8xl text-center">
              <FontAwesomeIcon icon={faClockRotateLeft} />
            </div>
            <div className="font-bold text-4xl text-center pt-10">Recurring Task</div>
            <div className="text-md text-center pt-5 text-text dark:text-text-dark">Great for tasks that are going to appear at a set interval</div>
            <div className="text-xs text-center text-muted">(e.g. Every month on the 1st) </div>
          </div>
          <div
            className="cursor-pointer bg-card dark:bg-card-dark p-10 w-96 my-5 rounded-lg shadow-xl hover:shadow-sm hover:bg-text-dark hover:dark:bg-text hover:text-primary"
            onClick={() => navigate("/addtask/new/interim")}
          >
            <div className="text-8xl text-center">
              <FontAwesomeIcon icon={faThumbTack} />
            </div>
            <div className="font-bold text-4xl text-center pt-10">Interim Task</div>
            <div className="text-md text-center pt-5 text-text dark:text-text-dark">Great for tasks that can't be predicted or set at a set interval</div>
            <div className="text-xs text-center text-muted">(e.g. Adhoc state request for resources)</div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default TaskCreationSelector;
